import classNames from 'classnames'
import { Button } from 'components/common/Button'
import { Icon } from 'components/common/Icon'
import { Separator } from 'components/common/Separator'
import { useOverlay } from 'contexts'
import useTranslation from 'next-translate/useTranslation'
import { ReactNode } from 'react-markdown/lib/react-markdown'

type Props = {
  title: ReactNode
  body: ReactNode
  confirmButton: ReactNode
  className?: string
  onCancel?: VoidFunction
  showCloseButton?: boolean
}

export const ConfirmModal = ({
  title,
  body,
  confirmButton,
  onCancel,
  className,
  showCloseButton = true,
}: Props) => {
  const { t } = useTranslation('common')
  const { setIsOpen } = useOverlay()

  const onCancelHandler = () => {
    if (onCancel) {
      onCancel()
    } else {
      setIsOpen(false)
    }
  }

  return (
    <div
      className={classNames('relative h-auto w-full max-w-[400px]', className)}
    >
      <header className='relative flex items-center rounded-t-lg bg-cool-150 p-6'>
        {title}

        {showCloseButton && (
          <button
            type='button'
            onClick={onCancelHandler}
            className='absolute right-6 top-6 text-cool-600'
            aria-label='Close'
          >
            <Icon name='close' />
          </button>
        )}
      </header>

      <Separator />

      <div className='bg-cool-50 p-6'>{body}</div>

      <Separator />

      <footer className='flex items-center justify-end space-x-3 rounded-b-lg bg-cool-150 p-6'>
        <Button style='outline' onClick={onCancelHandler}>
          {t('cancel')}
        </Button>

        {confirmButton}
      </footer>
    </div>
  )
}
